import React, { useState, useEffect } from 'react';

const styles = {
  nav: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    transition: 'background 0.3s, box-shadow 0.3s',
  },
  navScrolled: {
    background: 'rgba(10,74,190,1)',
    boxShadow: '0 1px 0 rgba(0,0,0,0.08)',
    // borderBottom: '4px solid #f9d800'
  },
  navTop: {
    background: 'rgba(10,74,190,1)',
    // background: 'linear-gradient(to bottom, rgba(10,74,190,1) 0%, rgba(10,74,190,0.85) 0%, rgba(10,74,190,0) 100%)',
  },
  inner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '65px',
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
  },
  logoImg: {
    height: '35px',
    objectFit: 'contain',
  },
  links: {
    background: '#0a4abe',
    display: 'flex',
    alignItems: 'center',
    gap: '32px',
    paddingLeft: '24px',
    paddingRight: '24px',
    borderRadius: '8px'
  },
  link: {
    fontFamily: "'Inter', sans-serif",
    fontWeight: 500,
    fontSize: '15px',
    color: '#ffffff',
    transition: 'color 0.2s',
  },
  cta: {
    // background: '#0a4abe',
    color: '#ffffff',
    padding: '10px 22px',
    borderRadius: '8px',
    fontFamily: "'Inter', sans-serif",
    fontWeight: 500,
    fontSize: '15px',
    transition: 'background 0.2s, transform 0.15s',
  },
  hamburger: {
    display: 'none',
    flexDirection: 'column',
    gap: '5px',
    padding: '4px',
    cursor: 'pointer',
    background: 'none',
    border: 'none',
  },
  bar: {
    width: '24px',
    height: '2px',
    background: '#ffffff',
    borderRadius: '2px',
    transition: 'all 0.3s',
  },
  mobileMenu: {
    background: '#ffffff',
    borderTop: '1px solid #f0efe9',
    padding: '16px 24px 24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  mobileLink: {
    fontFamily: "'Inter', sans-serif",
    fontSize: '16px',
    color: '#2a2a27',
    padding: '8px 0',
    borderBottom: '1px solid #f0efe9',
  },
  mobileCta: {
    background: '#0a4abe',
    color: '#fff',
    padding: '12px',
    borderRadius: '8px',
    textAlign: 'center',
    fontFamily: "'Inter', sans-serif",
    fontWeight: 500,
    marginTop: '4px',
  },
};

const navLinks = [
  { label: 'Services', href: '#services' },
  { label: 'Coverage & Process', href: '#coverage' },
  { label: 'Who We Serve', href: '#audience' },
  { label: 'Why Us', href: '#why-us' },
  { label: 'About', href: '#about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
      <nav style={{ ...styles.nav, ...(scrolled ? styles.navScrolled : styles.navTop) }}>
        <div className="dh-container">
          <div style={styles.inner}>
            <a href="#home" style={styles.logo}>
              <img src="/assets/logo.png" alt="Delivery Hub" style={styles.logoImg} />
            </a>

            {/* Desktop links */}
            <div style={styles.links} className="nav-desktop-links">
              {navLinks.map(l => (
                  <a key={l.label} href={l.href} style={styles.link}
                     onMouseEnter={e => e.target.style.color = '#f9d800'}
                     onMouseLeave={e => e.target.style.color = '#ffffff'}
                  >{l.label}</a>
              ))}
              <a href="#contact" style={styles.cta}
                 onMouseEnter={e => { e.target.style.background = '#083a96'; }}
                 onMouseLeave={e => { e.target.style.background = '#0a4abe'; }}
              >Get a Quote</a>
            </div>

            {/* Hamburger */}
            <button style={styles.hamburger} onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu"
                    className="nav-hamburger">
              <span style={styles.bar}></span>
              <span style={styles.bar}></span>
              <span style={styles.bar}></span>
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {menuOpen && (
            <div style={styles.mobileMenu} className="nav-mobile-menu">
              {navLinks.map(l => (
                  <a key={l.label} href={l.href} style={styles.mobileLink} onClick={() => setMenuOpen(false)}>{l.label}</a>
              ))}
              <a href="#contact" style={styles.mobileCta} onClick={() => setMenuOpen(false)}>Get a Quote</a>
            </div>
        )}

        <style>{`
        @media (max-width: 768px) {
          .nav-desktop-links { display: none !important; }
          .nav-hamburger { display: flex !important; }
        }
      `}</style>
      </nav>
  );
}